import { createContext, useContext, useMemo } from 'react'
import type { ReactNode } from 'react'
import type { MockDataStore } from '@/data/types'
import { mockEmployees } from '@/data/mockEmployees'

const MockDataContext = createContext<MockDataStore | null>(null)

export function MockDataProvider({ children }: { children: ReactNode }) {
  const store = useMemo<MockDataStore>(
    () => ({ employees: mockEmployees }),
    [],
  )
  return <MockDataContext.Provider value={store}>{children}</MockDataContext.Provider>
}

export function useMockData(): MockDataStore {
  const ctx = useContext(MockDataContext)
  if (!ctx) throw new Error('useMockData must be used within MockDataProvider')
  return ctx
}
